export default __webpack_public_path__ + "static/media/courses.310c72d7.svg";